import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LimitePlataformaConta } from "../model/limites-plataforma";

@Injectable()
export class LimitesPlataformaService {
    private api: string;

    constructor(private httpClient: HttpClient) {
        this.api = '/api/limitesplataforma';
    }

    public obterLimitesPlataformaConta() {
        return this.httpClient.get<LimitePlataformaConta>(`${this.api}/limites-conta`);
    }
}
